var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"},on:{"click":_vm.download}},[_vm._v(_vm._s(_vm.params.data.fileName))])}
var staticRenderFns = []

export { render, staticRenderFns }